import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ children }) => {
  const isAdmin = localStorage.getItem("adminLogin");
  return isAdmin ? children : <Navigate to="/admin" />;
};

export default ProtectedRoute;
